import React, { createContext, useState, useEffect } from 'react';
import { useRsvp } from '@/store';

const initialState = {};

const EventContext = createContext(initialState);

function EventContextProvider({ children, data }) {
  const [ticketTypes, setTicketTypes] = useState([]);
  const { rsvp, isActive: rsvpisActive } = useRsvp();

  useEffect(() => {
    if (data?.ticket_types_information) {
      if (rsvpisActive && rsvp.type === 'hold') {
        const {
          event: { use_seats },
        } = data.event_information;

        let rspvTickets = [];
        if (use_seats) {
          rsvp.detail.map((seat) => {
            seat.tickets.map((ticket) => {
              if (!rspvTickets.includes(ticket)) {
                rspvTickets = [...rspvTickets, ticket];
              }
            });
          });
        } else {
          rspvTickets = rsvp.detail.map((t) => t.ticket_id);
        }

        setTicketTypes(
          data.ticket_types_information
            .filter((ticket) => {
              return rspvTickets.includes(ticket.ticket_type_id);
            })
            .map((ticket) => {
              const rsvpTicket = rsvp.detail.find(
                (t) => t.ticket_id === ticket.ticket_type_id,
              );
              if (rsvpTicket) {
                return {
                  ...ticket,
                  max_per_sale: rsvpTicket?.available || ticket.max_per_sale,
                };
              }
              return ticket;
            }),
        );
      } else {
        setTicketTypes(data.ticket_types_information);
      }
    }
  }, [data, rsvp]);

  return (
    <EventContext.Provider
      value={{
        event: data.event_information,
        ticketTypes,
        hasEventAvailability: data?.ticket_types_information?.some(
          (ticket) => ticket.availability > 0,
        ),
      }}
    >
      {children}
    </EventContext.Provider>
  );
}

export { EventContextProvider, EventContext };
